import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  actions: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  content: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
    }
  },
  fullNameText: {
    fontWeight: 700,
    fontSize: '18px',
  },
  info: {
    display: 'flex',
    flex: 1,
    gap: theme.spacing(2),
    position: 'relative',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
    }
  },
  mobileCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    maxWidth: '100vw',
    padding: theme.spacing(3, 2),
  },
  nameLine: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
  },
  rightBlock: {
    flex: 1,
    justifyContent: 'flex-start',
    overflow: 'hidden',
  },
}));
